module.exports = __webpack_public_path__ + "static/img/login_read_normal@3x.f2c192f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_read_normal@3x.png
// module id = SBRT
// module chunks = 1